import {
  Button,
  createMuiTheme,
  Grid,
  InputLabel,
  Link,
  Theme,
  List,
  ListItem,
  makeStyles,
  Popover,
  TextField,
  Modal,
  createStyles,
  Fade,
  Typography,
  FormControl,
  FormControlLabel,
  Radio,
  Backdrop,
  RadioGroup,
  Tooltip,
} from "@material-ui/core";
import { ArrowBackIos, FilterList, Search, Settings } from "@material-ui/icons";
import React, { useEffect, useState, useCallback } from "react";
import { ThemeProvider } from "@material-ui/styles";
import HomeHeaderMenu from "../../../Home/HomeHeaderMenu";
import { useHistory } from "react-router";
import MaterialTable, { MTableBody } from "material-table";
import DataService from "../../../../Service";
import createData from "../../../../Service/create_data_service";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../../Components/Snackbar/SnackbarActions";
import OnboardCoachDetails from "../../../Home/OnboardCoachDetails";
import Requestforassistance from "../../../Home/Requestforassistance";
import { TooltipWrapper } from "../../../../Common/Utils/common_utils";

const CoachList = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [userData, setUserData] = useState([]);
  const history = useHistory();
  const [searchText, setSearchText] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState("All");
  const [requestOnBoardCoaches, setRequestOnBoardCoaches] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentSelection, setcurrentSelection] = useState(null);
  const [fieldsError, setFieldsError] = useState({});
  const [busy, setBusy] = useState(null);
  const [requestforassistance, setRequestforassistance] = useState(false);
  const [pageSize, setPageSize] = useState(20);
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(100);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const moduleSetup = () => {
    const params = {
      search: searchText || null,
      filter: filter,
      page: page + 1 || 1,
      count_per_page: pageSize || 20,
    };
    setIsLoading(true);
    DataService.getDirectData(
      `/coach_panels/listing_external_coach_list`,
      params
    ).then((res) => {
      setIsLoading(false);
      if (res.success) {
        const moduleSetups = res["external_coach_lists"];
        setTotalCount(res.total_count)
        setUserData(moduleSetups);
      }
    });
  };

  useEffect(() => {
    moduleSetup();
  }, [filter]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      moduleSetup();
    }, 500);

    // clean up function
    return () => clearTimeout(timeoutId);
  }, [searchText]);
useEffect(()=>{
  moduleSetup();
},[pageSize,page])

  const validateFields = (formData) => {
    let valid = true;
    let error = {};

    for (let pair of formData.entries()) {
      const key = pair[0];
      const val = pair[1];

      if (!val || val.length < 3) {
        // @ts-ignore
        error[key] = true;
        valid = false;
      }
    }

    if (!valid) {
      setFieldsError(error);
    }

    return valid;
  };

  const requestCoachHandler = (event) => {
    const formData = new FormData(event.target);

    // validation
    if (!validateFields(formData)) return;

    setBusy("requesting");
    createData(formData, "requestCoaches")
      .then((res) => {
        if (res.success) {
          dispatch(showSnackbar("success", ["Success!"]));

          setRequestOnBoardCoaches(false);
          setRequestforassistance(false);
        }
      })
      .catch((err) => {
        if (!err.success) {
          dispatch(showSnackbar("error", ["Something went wrong!"]));
        }
      })
      .finally(() => setBusy(null));
  };

  const columns = [
    { field: "full_name", title: "Coach name", },
    { field: "location", title: "Location",  },
    { field: "language", title: "Language", },
    { field: "gender", title: "Gender",hidden:true },
    {
      field: "email",
      title: "Email",
      hidden:true
    },
    { field: "type_of_partner", title: "Type of partner",hidden:true },
    { field: "availability", title: "Availability",hidden:true },
  ];

  const theme = createMuiTheme({
    overrides: {},
  });
  const actions = [
    {
      icon: () => (
        <Tooltip
          title={<TooltipWrapper text={"View user profile"} />}
          children={
            <Button
              disableElevation
              variant="contained"
              color="secondary"
              className={`${classes.btnSearch} ${classes.f12} ${classes.btnView}`}
              style={{marginRight:"1.25rem"}}
            >
              View profile
            </Button>
          }
        />
      ),
      onClick: (event, rowData) => {
        if (rowData?.roles?.length > 1) {
          setcurrentSelection(rowData);
        } else {
          history.push("CoachDetail", {
            id: rowData.id,
            coachType: "external",
            currentSelection: rowData,
            selectedRole: rowData?.roles[0],
          });
        }
      },
    },
  ];

  const options = {
    headerStyle: { fontWeight: "bold" },
    cellStyle: { fontSize: 14 },
    actionsColumnIndex: -1,
    // toolbar: false,
    search: false,
    emptyRowsWhenPaging: false,
    columnsButton: true,
    total: totalCount,
    pageSize:pageSize,
    pageSizeOptions:[5,20,50,75,100],
  };

  const roleModel = useCallback(
    () => (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={Boolean(currentSelection)}
        onClose={handleClose}
        closeAfterTransition
        onBackdropClick={() => setcurrentSelection(null)}
      >
        <Fade in={Boolean(currentSelection)}>
          <div className={`${classes.paper} ${classes.modalInner}`}>
            <Typography variant="h1" className={classes.headerStyle}>
              Choose Role
            </Typography>
            <FormControl
              component="fieldset"
              style={{ marginTop: 20, marginBottom: 20 }}
            >
              <RadioGroup
                aria-label="role"
                name="role"
                onChange={(event) =>
                  history.push("CoachDetail", {
                    id: currentSelection.id,
                    coachType: "external",
                    currentSelection,
                    selectedRole: event.target.value,
                  })
                }
              >
                {currentSelection?.roles?.filter(el=>[ "Assessor", "Executive Coach","Mediator" ,"Facilitator", "Mentor"].includes(el)).map((option) => {
                  return (
                    <FormControlLabel
                      style={{ textTransform: "capitalize" }}
                      value={option}
                      control={<Radio />}
                      label={
                        <Typography variant="subtitle1">{option}</Typography>
                      }
                    />
                  );
                })}
              </RadioGroup>
            </FormControl>
          </div>
        </Fade>
      </Modal>
    ),
    [classes.modal, classes.modalInner, classes.paper, currentSelection?.roles]
  );

  return (
    <div>
      <HomeHeaderMenu />
      <Grid
        container
        direction="row"
        alignItems="center"
        justify="center"
        style={{ backgroundColor: "#B4B4B440" }}
      >
        <Grid
          item
          xs={11}
          style={{ margin: "25px 0", backgroundColor: "#fff" }}
        >
          <Grid
            container
            direction="row"
            alignItems="center"
            justify="center"
            className={classes.bgGray}
          >
            <Grid item xs={5}>
              <ArrowBackIos
                onClick={() => {
                  history.goBack();
                }}
              />
              <span
                style={{
                  verticalAlign: "super",
                  fontWeight: 700,
                  paddingLeft: 5,
                }}
              >
                Coach list (external)
              </span>
            </Grid>
            <Grid item xs={7}>
              <div style={{ float: "right" }}>
                <Button
                  disableElevation
                  variant="contained"
                  color="secondary"
                  className={classes.btnComplete}
                  onClick={() => setRequestOnBoardCoaches(true)}
                >
                  Onboard coach
                </Button>
                <Button
                  disableElevation
                  variant="contained"
                  color="secondary"
                  className={classes.btnComplete}
                  style={{ textTransform: "none" }}
                  onClick={() => setRequestforassistance(true)}
                >
                  Request for assistance/alternative coaches
                </Button>
                <Button
                  disableElevation
                  variant="contained"
                  color="secondary"
                  startIcon={<Search />}
                  className={classes.btnSearchBlue}
                  onClick={() => {
                    history.push("/CoachSearch");
                  }}
                >
                  Search coach
                </Button>
              </div>
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            alignItems="center"
            justify="center"
            style={{ padding: 20 }}
          >
            <Grid item xs={6}>
              <Grid container direction="row" alignItems="flex-end">
                <Grid item>
                  <Search />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    style={{ width: "100%" }}
                    id="input-with-icon-grid"
                    label="Search coach name"
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <div style={{ float: "right" }}>
                <Button
                  disableElevation
                  style={{ marginRight: 20 }}
                  variant="contained"
                  color="secondary"
                  onClick={handleClick}
                  startIcon={<FilterList />}
                  className={`${classes.btnSearch} ${classes.f12}`}
                >
                  {filter}
                </Button>
                <Popover
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                >
                  <List component="nav" aria-label="main mailbox folders">
                    {[
                      { name: "All" },
                      { name: "Assessors" },
                      { name: "Executive coaches" },
                      { name: "Facilitators" },
                      { name: "Mediators" },
                      { name: "Mentors" },
                    ].map((e) => (
                      <Link
                        onClick={() => {
                          setFilter(e.name);
                          handleClose();
                        }}
                      >
                        <ListItem style={{ paddingBottom: 0, paddingTop: 0 }}>
                          <InputLabel style={{ marginLeft: 20, minWidth: 100 }}>
                            <h4>{e.name}</h4>
                          </InputLabel>
                        </ListItem>
                      </Link>
                    ))}
                  </List>
                </Popover>
                {/* <Button
                  disableElevation
                  variant="contained"
                  color="secondary"
                  startIcon={<Settings />}
                  className={`${classes.btnSearch} ${classes.f12}`}
                >
                  Customize
                </Button> */}
              </div>
            </Grid>
          </Grid>
          <Grid direction="row" style={{ padding: 20 }}>
            <ThemeProvider theme={theme}>
              <Grid xs={12}>
              <MaterialTable
      options={options}
      data={userData}
      title={""}
      actions={actions}
      columns={columns}
      totalCount={totalCount}
      page={page}
      components={{Body:(props)=>{
        return <MTableBody  {...props} />
      }}}
      localization={{
        toolbar: {
          nRowsSelected: "{0} Booking selected",
          searchPlaceholder: "Search Coachee name",
          addRemoveColumns: (
            <Typography
              variant="subtitle1"
              style={{ fontWeight: 700 }}
              className={classes.textPrimary}
            >
              Add or remove columns{" "}
            </Typography>
          ),
          exportAriaLabel: "Download as CSV",
          exportTitle: <TooltipWrapper text="Download as CSV" />,
          exportName: "Download as CSV",
          showColumnsTitle: <TooltipWrapper text="Show columns" />,
          showColumnsAriaLabel: "Show columns",
        },
      }}
      onChangePage={(page) => {
        setPage(page);
      }}
      onChangeRowsPerPage={(pageSize) => {
        setPageSize(pageSize);
      }}
    />
              </Grid>
            </ThemeProvider>
          </Grid>
        </Grid>
      </Grid>
      {currentSelection?.roles && roleModel()}

      {requestOnBoardCoaches && (
        <OnboardCoachDetails
          isRequesting={busy === "requesting"}
          title="Onboard coach"
          handleClose={() => setRequestOnBoardCoaches(false)}
          submitHandler={requestCoachHandler}
          errors={fieldsError}
          setErrors={setFieldsError}
        />
      )}
      {requestforassistance && (
        <Requestforassistance
          isRequesting={busy === "requesting"}
          title="Request for assistance"
          handleClose={() => setRequestforassistance(false)}
          submitHandler={requestCoachHandler}
          errors={fieldsError}
          setErrors={setFieldsError}
        />
      )}
    </div>
  );
};
export default CoachList;

const useStyles = makeStyles((theme) =>
  createStyles({
    bgGray: {
      backgroundColor: "#F7F7F7",
      padding: 20,
    },
    btnComplete: {
      backgroundColor: theme.palette.secondary.main,
      textTransform: "none",
      fontSize: 14,
      marginRight: 20,
    },
    btnSearch: {
      backgroundColor: theme.palette.secondary.main,
      textTransform: "none",
      fontSize: 14,
    },
    btnSearchBlue: {
      backgroundColor: theme.palette.secondary.main,
      textTransform: "none",
      fontSize: 14,
    },
    f12: { fontSize: 12 },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: 20,
    },
    paper: {
      backgroundColor: "#fff",
      boxShadow: theme.shadows[5],
      padding: 20,
      textAlign: "left",
    },
    modalInner: {
      width: 600,
      borderRadius: 10,
      maxHeight: 500,
      overflow: "auto",
    },
    headerStyle: {
      color: theme.palette.primary.main,
      textAlign: "left",
    },
    btnView: {
      "&:hover": {
        backgroundColor: "#EF7000",
      },
    },
  })
);
